import { SVGProps, memo } from "react";

const SvgLogoWhite = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 449 145" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M213.071 89.6559L208.103 114.544C205.898 124.653 199.816 131.357 187.417 131.357C173.155 131.357 169.386 122.533 172.513 110.067C176.924 92.4403 191.357 87.1928 213.071 89.6559ZM235.513 54.0806L220.374 55.0444L215.577 79.4181C209.795 79.2039 207.975 79.0112 201.144 79.0112C179.837 79.0112 161.228 87.9639 156.302 108.996C151.87 127.973 162.641 142.666 186.132 142.666C210.18 142.666 220.652 130.136 224.399 112.466L235.513 54.0806Z"
      fill="white"
    />
    <path
      d="M71.1379 90.7055C48.91 88.6922 29.8086 90.5555 29.4873 98.0733C29.0162 109.403 66.1056 99.5083 65.3989 120.369C64.3496 150.997 12.7843 143.951 0 140.053L2.31273 130.971C24.3265 134.462 47.5609 134.762 48.0749 122.618C48.6102 109.703 11.3495 121.312 12.2275 100.408C12.8699 84.8583 36.1686 76.4625 74.2644 82.0526L71.1379 90.7055Z"
      fill="white"
    />
    <path
      d="M131.033 111.545C127.821 124.332 117.692 132.342 105.636 132.342C93.0232 132.342 87.327 125.017 90.7105 111.545C93.944 98.7584 104.18 90.1912 116.236 90.1912C128.314 90.1912 134.246 98.7584 131.033 111.545ZM118.206 79.7178C96.1068 79.7178 78.3331 92.5258 73.986 111.545C69.5961 130.628 81.5024 143.372 103.58 143.372C125.68 143.372 143.432 130.607 147.822 111.545C152.169 92.5043 140.284 79.7178 118.206 79.7178Z"
      fill="white"
    />
    <path
      d="M373.485 143.072H354.276C342.627 132.128 320.335 106.961 303.953 80.3174H318.065C333.59 101.8 373.485 143.072 373.485 143.072Z"
      fill="white"
    />
    <path
      d="M393.614 18.4195L402.437 0L404.964 18.7408L422.994 12.4225L410.381 28.5717L424.044 39.1736L405.799 40.5658L404.814 60.0347L394.685 45.6418L379.781 59.3922L385.37 40.0303L367.81 37.6315L384.899 27.9077L377.896 11.223L393.614 18.4195Z"
      fill="white"
    />
    <path
      d="M431.068 111.738C427.813 124.739 417.534 132.899 405.263 132.899C392.436 132.899 386.676 125.445 390.124 111.738C393.379 98.7799 403.786 90.0413 416.056 90.0413C428.284 90.0413 434.323 98.7584 431.068 111.738ZM418.005 79.418C395.563 79.418 377.532 92.3973 373.078 111.738C368.645 131.1 380.723 144.1 403.165 144.1C425.607 144.1 443.638 131.1 448.092 111.738C452.525 92.3973 440.447 79.418 418.005 79.418Z"
      fill="white"
    />
    <path
      d="M289.392 137.697C325.667 117.564 357.189 86.5933 379.524 59.7993C363.463 110.132 324.768 137.183 289.392 137.697Z"
      fill="white"
    />
    <path
      d="M275.022 89.0563C281.982 89.0563 285.751 91.5836 285.751 96.4026C285.751 109.211 260.825 108.375 249.818 106.126C253.694 96.5311 262.431 89.0563 275.022 89.0563ZM300.677 95.7173C300.677 86.4433 293.289 79.6323 276.521 79.6323C249.325 79.6323 231.659 97.2808 231.659 119.149C231.659 133.263 243.372 145 264.786 145C279.541 145 289.37 137.718 289.37 137.718C270.611 139.731 247.548 137.718 247.548 117.671C247.548 116.878 247.591 116.064 247.655 115.272C273.266 120.562 300.677 114.115 300.677 95.7173Z"
      fill="white"
    />
  </svg>
);

const Memo = memo(SvgLogoWhite);
export default Memo;
